module.exports = __webpack_public_path__ + "img/txt_series_101.5d463cfa.png";